<template>
  <a role="button" class="whitespace-nowrap text-sm" @click="showChangeRoleDialog">Change role</a>
</template>

<script>
export default {
  props: {
    membership: {
      type: Object,
      required: true,
    },
    roleOptions: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    showChangeRoleDialog() {
      this.$modal.show({
        component: () => import('./ChargeRoleDialog.vue'),
        props: {
          membership: this.membership,
          roleOptions: this.roleOptions,
        },
        on: {
          changed: () => {
            this.$emit('changed');
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
